import React, { Component } from "react";
import _ from 'i18n';
import {Col, Row} from "antd";

export default class AppTypeStatsCard extends Component {

  render() {
    const { selected, appType, nbrActivities, paidRegistrant, notpaidRegistrant, formation, cycle, all_in, inDistinctPaidRegistrant, inDistinctNotPaidRegistrant, hasPaidUserIds, hasNotPaidUserIds} = this.props;
    const activities = nbrActivities ? nbrActivities : ((formation && formation.nbrActivities ? parseInt(formation.nbrActivities) : 0) + (cycle && cycle.nbrActivities ? parseInt(cycle.nbrActivities) : 0) + (all_in && all_in.nbrActivities ? parseInt(all_in.nbrActivities) : 0));
    const paidRegistrants = paidRegistrant ? paidRegistrant : (formation && formation.hasPaidUserIds && cycle && cycle.hasPaidUserIds && all_in && all_in.hasPaidUserIds ?  [...new Set([...formation.hasPaidUserIds ,...cycle.hasPaidUserIds,...all_in.hasPaidUserIds])].length : 0);
    const freeRegistrants = notpaidRegistrant ? notpaidRegistrant : (formation && formation.hasNotPaidUserIds && cycle && cycle.hasNotPaidUserIds && all_in && all_in.hasNotPaidUserIds ?  [...new Set([...formation.hasNotPaidUserIds ,...cycle.hasNotPaidUserIds,...all_in.hasNotPaidUserIds])].length : 0);
    const registrants = hasPaidUserIds && hasNotPaidUserIds ? [...new Set([...hasPaidUserIds ,...hasNotPaidUserIds])].length  : (formation && formation.hasPaidUserIds && formation.hasNotPaidUserIds && cycle && cycle.hasPaidUserIds && cycle.hasNotPaidUserIds && all_in && all_in.hasPaidUserIds && all_in.hasNotPaidUserIds ?  [...new Set([...formation.hasPaidUserIds ,...cycle.hasPaidUserIds,...all_in.hasPaidUserIds, ...formation.hasNotPaidUserIds ,...cycle.hasNotPaidUserIds,...all_in.hasNotPaidUserIds])].length : 0);
    const inDistinctPaidRegistrants = inDistinctPaidRegistrant ? inDistinctPaidRegistrant : ((formation && formation.inDistinctPaidRegistrant ? parseInt(formation.inDistinctPaidRegistrant) : 0) + (cycle && cycle.inDistinctPaidRegistrant ? parseInt(cycle.inDistinctPaidRegistrant) : 0) + (all_in && all_in.inDistinctPaidRegistrant ? parseInt(all_in.inDistinctPaidRegistrant) : 0));
    const inDistinctNotPaidRegistrants = inDistinctNotPaidRegistrant ? inDistinctNotPaidRegistrant : ((formation && formation.notPaidRegistrant ? parseInt(formation.notPaidRegistrant) : 0) + (cycle && cycle.notPaidRegistrant ? parseInt(cycle.notPaidRegistrant) : 0) + (all_in && all_in.notPaidRegistrant ? parseInt(all_in.notPaidRegistrant) : 0));
    const inDistinctRegistrants = parseInt(inDistinctPaidRegistrants) + parseInt(inDistinctNotPaidRegistrants);

    return (
    <div>
      <div className={!selected ? 'event-stats-global-div mr-4' :
        (appType == 'global' ? 'event-stats-global-div event-stats-global-div-blue mr-4' :
            (appType == 'registering' ? 'event-stats-global-div event-stats-global-div-light-blue mr-4' :
                (appType == 'cycle_registering' ? 'event-stats-global-div event-stats-global-div-orange mr-4' : 'event-stats-global-div event-stats-global-div-pink mr-4')
            )
        )
      }>
        <div className={!selected ? 'event-stats-global-title mt-4 ml-4' : 'event-stats-global-title mt-4 ml-4 event-stats-div-font'}>{appType == 'global' ? _('GLOBAL') : (appType == 'registering' ? _('registering')+'s' : (appType == 'cycle_registering' ? _('cycle_registering')+'s' : 'All In Live') )}</div>
        <Row className={'event-stats-global-title mt-3 mb-3'}>
          <Col span={6} className={'flex justify-center items-center flex-col event-stats-global-col'} style={{height: '85px'}}><span className={!selected ? 'event-stats-global-title' : 'event-stats-global-title event-stats-div-font'}>{activities >= 10 ? activities : '0'+activities}</span><span className={!selected ? 'event-stats-global-label' : 'event-stats-global-label event-stats-div-font'}>{_('ACTIVITIES')}</span></Col>
          <Col span={6} className={'flex justify-center items-center flex-col event-stats-global-col'}>
            <span className={!selected ? 'event-stats-global-title' : 'event-stats-global-title event-stats-div-font'}>
              {registrants >= 10 ? registrants : '0'+registrants}
            </span>
            <span className={!selected ? 'event-stats-global-label' : 'event-stats-global-label event-stats-div-font'}>
              {_('PERSONS')}
            </span>
            <hr style={{margin: '0px', marginTop: '9px', width : '51px'}}/>
            <span className={!selected ? 'event-stats-global-title' : 'event-stats-global-title event-stats-div-font'}>
              {inDistinctRegistrants >= 10 ? inDistinctRegistrants : '0'+inDistinctRegistrants}
            </span>
            <span className={!selected ? 'event-stats-global-label' : 'event-stats-global-label event-stats-div-font'}>
              {_('REGISTERED')}
            </span>
          </Col>
          <Col span={6} className={'flex justify-center items-center flex-col event-stats-global-col'}>
            <span className={!selected ? 'event-stats-global-title' : 'event-stats-global-title event-stats-div-font'}>
              {paidRegistrants >= 10 ? paidRegistrants : '0'+paidRegistrants}
            </span>
            <span className={!selected ? 'event-stats-global-label' : 'event-stats-global-label event-stats-div-font'}>
              {_('PERSONS')}
            </span>
            <hr style={{margin: '0px', marginTop: '9px', width : '51px'}}/>
            <span className={!selected ? 'event-stats-global-title' : 'event-stats-global-title event-stats-div-font'}>
              {inDistinctPaidRegistrants >= 10 ? inDistinctPaidRegistrants : '0'+inDistinctPaidRegistrants}
            </span>
            <span className={!selected ? 'event-stats-global-label' : 'event-stats-global-label event-stats-div-font'}>
              {_('PAYING')}
            </span>
          </Col>
          <Col span={6} className={'flex justify-center items-center flex-col p-1'}>
            <span className={!selected ? 'event-stats-global-title' : 'event-stats-global-title event-stats-div-font'}>
              {freeRegistrants >= 10 ? freeRegistrants : '0'+freeRegistrants}
            </span>
            <span className={!selected ? 'event-stats-global-label' : 'event-stats-global-label event-stats-div-font'}>
              {_('PERSONS')}
            </span>
            <hr style={{margin: '0px', marginTop: '9px', width : '51px'}}/>
            <span className={!selected ? 'event-stats-global-title' : 'event-stats-global-title event-stats-div-font'}>
              {inDistinctNotPaidRegistrants >= 10 ? inDistinctNotPaidRegistrants : '0'+inDistinctNotPaidRegistrants}
            </span>
            <span className={!selected ? 'event-stats-global-label' : 'event-stats-global-label event-stats-div-font'}>
              {_('FREE')}
            </span>
          </Col>
        </Row>
        <div className={'flex justify-center items-center'}>
          {selected ? (appType =='global' ? <img src="/img/icons/div-select-icon.svg"/> :
            (appType =='registering' ? <img src="/img/icons/select-light-blue.svg"/> :
              (appType == 'cycle_registering' ? <img src="/img/icons/select-orange.svg"/> : <img src="/img/icons/select-pink.svg"/>)
            )
            ) : null }
        </div>
      </div>
    </div>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/AppTypeStatsCard.js